import {
  MDBAutocomplete,
  MDBCol,
  MDBIcon,
  MDBInput,
  MDBRow,
  MDBSelect,
} from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  AddNewBillingGroup,
  getMisc,
  LocAddressSeach,
} from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import { Controller, useForm } from "react-hook-form";
import { CANADA, USA } from "../../../components/images";

const AddBillingGroup = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [locAddress, setlocAddress] = useState([]);
  const [groupType, setgroupType] = useState([]);
  const [states, setstates] = useState([]);
  const [countries, setcountries] = useState([]);
  const [invoiceGroups, setinvoiceGroups] = useState([]);
  const [statelist, setstatelist] = useState([]);
  const [addressReasults, setAddressReasults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setisDisplay] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const allowAPI = useRef(true);

  const {
    register,
    handleSubmit,
    formState: { isDirty, dirtyFields, errors },
    setValue,
    watch,
    getValues,
    clearErrors,
    setError,
    control,
  } = useForm({
    defaultValues: {
      zip: "",
      city: "",
      country: "",
      state: 0,
      bgrp_name: "",
      bgrp_type: 1,
      new_loc_id: -1,
      specific_loc: "",
      street_addr1: "",
      street_addr2: "",
      default_invoice: 10000,

    },
  });

  useEffect(() => {
    async function getBillingInfoMisc(e) {
      const response = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        { misc: ["billing_settings_info"] }
      );
      console.log(response);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const tdata = await response.json();
      if (!tdata) {
        window.alert(`info with id  not found`);
        navigate("/");
      }
      console.log(
        "billing info misc details ::::::::: " + JSON.stringify(tdata)
      );

      setlocAddress(
        (tdata?.misc?.billing_settings_info?.location_list ?? []).map(
          (loc) => ({
            text: loc.location_name,
            value: parseInt(loc.location_id),
          })
        )
      );
      setgroupType(
        Object.entries(
          tdata?.misc?.billing_settings_info?.billing_group_types ?? {}
        ).map(([key, value]) => ({ text: value, value: parseInt(key) }))
      );
      setstatelist(tdata?.misc?.billing_settings_info?.state_list ?? []);
      setstates(
        (tdata?.misc?.billing_settings_info?.state_list ?? []).map((state) => ({
          text: state.sname,
          value: parseInt(state.sid),
        }))
      );
      setcountries(
        (tdata?.misc?.billing_settings_info?.country_list ?? []).map(
          (country) => ({ text: country.cname, value: country.ccode })
        )
      );
      setinvoiceGroups(
        (tdata?.misc?.billing_settings_info?.invoice_groups ?? []).map(
          (group) => ({
            text: group.group_name,
            value: parseInt(group.billing_group_id),
          })
        )
      );
    }
    getBillingInfoMisc();
  }, []);

  const onsubmit = async (data) => {
    let updates = {};
    if (isDirty) {
      updates = {
        reqid: 129,
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        bgrp_name: data.bgrp_name,
        bgrp_type: data.bgrp_type,
      };
      if (data.new_loc_id === -1) {
        updates.specific_loc = data.specific_loc;
        updates.street_addr1 = data.street_addr1;
        updates.street_addr2 = data.street_addr2;
        updates.zip = data.zip;
        updates.city = data.city;
        updates.country = data.country;
        updates.state = parseInt(data.state);
      } else {
        updates.new_loc_id = data.new_loc_id;
      }

      if (data.bgrp_type === 2) {
        updates.default_invoice = data.default_invoice;
      }

      console.log(updates);
      props.setIsloading(true);
      let saverep = await AddNewBillingGroup(updates);
      setTimeout(() => {
        props.setIsloading(false);
      }, 2000);
      let saverepeMsg = await saverep.json();
      console.log(saverepeMsg);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        localStorage.setItem("s_message", saverepeMsg.message);
        props.onClose();
        window.location.href = "/billinglanding";
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
            }
          });
        } else {
          localStorage.setItem("f_message", saverepeMsg.message);
          window.location.href = "/billinglanding";
        }
      }
    }
  };

  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleSearchAddressChange(searchValue) {
    try {
      clearErrors("street_addr1");
      setValue("street_addr1", searchValue, { shouldDirty: true });
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      const newTimeout = setTimeout(() => {
        sendApIRequest(searchValue);
      }, 500);
      // Update the typingTimeout state with the new timeout
      setTypingTimeout(newTimeout);
    } catch (error) {
      console.log(`Error in handleSearchAddressChange :::: ${error}`);
    }
  }

  function handleAddressSelect(address) {
    if (address.street_line) {
      // setaddressValue(address.street_line);
      setValue("street_addr1", address.street_line, { shouldDirty: true, shouldValidate: true });
      clearErrors("street_addr1");
    }
    if (address.secondary) {
      setValue("street_addr2", address.secondary, { shouldDirty: true, shouldValidate: true });
    } else {
      setValue("street_addr2", "", { shouldDirty: true, shouldValidate: true });
    }
    if (address.city) {
      setValue("city", address.city, { shouldDirty: true, shouldValidate: true });
      clearErrors("city");
    }
    if (address.state) {
      const stateObj = statelist.find((state) => state.statecode.trim() === address.state.trim());
      console.log("stateObj :::::::: " + JSON.stringify(stateObj));
      if (stateObj) {
        setValue("state", stateObj.sid, { shouldDirty: true });
        clearErrors("state");
      }
    }
    if (address.zipcode) {
      setValue("zip", address.zipcode, { shouldDirty: true, shouldValidate: true });
      clearErrors("zip");
    }

  }

  const sendApIRequest = async (searchValue) => {
    try {
      if (searchValue.trim() !== "" && allowAPI.current) {
        //if (searchValue.trim() !== "") {
        let update = {
          reqid: 84,
          search: searchValue,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        };
        setIsLoading(true);
        console.log("Request for the search :::::: " + JSON.stringify(update));
        const serverResponse = await LocAddressSeach(update);
        setIsLoading(false);
        if (!serverResponse.ok) {
          console.log("Network response was not ok");
          throw new Error("Network response was not ok");
        } else {
          const responseData = await serverResponse.json();
          console.log("Response Data:", JSON.stringify(responseData));
          let addressList = responseData?.message?.suggestions ?? [];
          setAddressReasults(addressList);
          if (addressList.length === 0) {
            setisDisplay(false);
          } else {
            setisDisplay(true);
          }
        }
      } else {
        allowAPI.current = true;
        setisDisplay(false);
      }
    } catch (error) {
      console.log(`Error in sendApIRequest for address search :::: ${error}`);
    }
  };

  return (
    <>
      <div className="tel-numbers">
        {t("name", {
          required: "Name is required",
        })}
      </div>
      <MDBInput maxLength={30}  {...register("bgrp_name", { required: "Name is required" })} />
      {errors.bgrp_name && (
        <p className="text-danger">{errors.bgrp_name.message}</p>
      )}

      <div className=" mt-3">
        <div className="tel-numbers">Billing Group Type</div>
        <div className="position-relative">

          <MDBSelect
            data={groupType}
            value={watch("bgrp_type")}
            onChange={(e) =>
              setValue("bgrp_type", parseInt(e.value), { shouldDirty: true })
            }
          />

          <MDBIcon icon="info-circle" className="position-absolute top-50 translate-middle BillingGroupTypePopup" style={{ left: "calc(100% - 32px)" }} />
        </div>
        {errors.bgrp_type && (
          <p className="text-danger">{errors.bgrp_type.message}</p>
        )}
      </div>

      <div className=" mt-3">
        <div className="tel-numbers">Location Address</div>
        <MDBSelect
          data={[{ text: "Add New Location", value: -1 }, ...locAddress]}
          value={watch("new_loc_id")}
          onChange={(e) =>
            setValue("new_loc_id", parseInt(e.value), { shouldDirty: true })
          }
        />
        {errors.new_loc_id && (
          <p className="text-danger">{errors.new_loc_id.message}</p>
        )}
      </div>
      {watch("new_loc_id") === -1 && (
        <>
          <div className="mt-3">
            <div className="tel-numbers">Street Address 1*</div>

            <Controller
            name="street_addr1"
            control={control}
            rules={{required:"Street Address 1 field should not be empty."}}
            render={({field})=>(
              <MDBAutocomplete
              data={addressReasults}
              // value={addressValue}
                value={field.value}
              // value={watch("street_addr1")}
              displayValue={(address) => address.street_line}
              isLoading={isLoading}
              // open={isDisplay}
              placeholder="Address 1"
              onSearch={handleSearchAddressChange}
              onSelect={(e) => {
                allowAPI.current = false;
                setisDisplay(false);
              }}
              itemContent={(address) => (
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    allowAPI.current = false;
                    handleAddressSelect(address);
                  }}
                >
                  {address.country &&
                                                <img src={address.country === "USA" ? USA : CANADA} className='me-3' width={25} />
                                             } 
                  {address.street_line || ""}
                  {address.secondary ? ", " + address.secondary : ""}
                  {address.city ? ", " + address.city : ""}
                  {address.state ? ", " + address.state : ""}
                  {address.zipcode ? ", " + address.zipcode : ""}
                </div>
              )}
            />
      )}
      />

            {/* <MDBInput
              {...register("street_addr1", {
                required: "Street address is required",
              })}
            /> */}
            {errors.street_addr1 && (
              <p className="text-danger">{errors?.street_addr1?.message}</p>
            )}
          </div>
          <div className="mt-3">
            <div className="tel-numbers">Street Address 2</div>
            <MDBInput {...register("street_addr2")} />
            {errors.street_addr2 && (
              <p className="text-danger">{errors?.street_addr2?.message}</p>
            )}
          </div>
          <div className="mt-3">
            <div className="tel-numbers">Specific Location*</div>
            <MDBInput
              {...register("specific_loc", {
                required: "Specific Location is required",
              })}
            />
            {errors.specific_loc && (
              <p className="text-danger">{errors.specific_loc.message}</p>
            )}
          </div>
        </>
      )}

      <MDBRow>
        {watch("new_loc_id") === -1 && (
          <>
            <MDBCol size={6}>
              <div className="mt-3">
                <div className="tel-numbers">State/Province*</div>
                <select
                  className="form-select"
                  value={watch("state")}
                  onChange={(e) =>
                    setValue("state", parseInt(e.target.value), { shouldDirty: true })
                  }
                  {...register("state", { required: "Please select your state." })}
                >
                  <option value="">--Select State--</option>
                  {states.map((state) => (
                    <option value={parseInt(state.value)}>{state.text}</option>
                  ))}
                </select>
                {errors.state && (
                  <p className="text-danger">{errors.state.message}</p>
                )}
              </div>
            </MDBCol>

            <MDBCol size={6}>
              <div className="mt-3">
                <div className="tel-numbers">Country*</div>
                <select
                  className="form-select"
                  value={watch("country")}
                  onChange={(e) =>
                    setValue("country", e.target.value, { shouldDirty: true })
                  }
                  {...register("country", { required: "Please select your country." })}
                >
                  <option value="">--Select Country--</option>
                  {countries.map((country) => (
                    <option value={country.value}>{country.text}</option>
                  ))}
                </select>
                {errors.country && (
                  <p className="text-danger">{errors.country.message}</p>
                )}
              </div>
            </MDBCol>
          </>
        )}
        <MDBCol size={6}>
          {watch("new_loc_id") === -1 && (
            <>
              <div className="mt-3">
                <div className="tel-numbers">City/Town*</div>

                <MDBInput
                  {...register("city", {
                    required: "City/Town is required.",
                  })}
                />
                {errors.city && (
                  <p className="text-danger">{errors.city.message}</p>
                )}
              </div>
            </>
          )}
          {watch("bgrp_type") === 2 && (
            <>
              <div className="mt-3">
                <div className="tel-numbers">Default Invoice*</div>
                <select
                  className="form-select"
                  value={watch("default_invoice")}
                  onChange={(e) =>
                    setValue("default_invoice", parseInt(e.target.value), {
                      shouldDirty: true,
                    })
                  }
                >
                  {invoiceGroups.map((invoice) => (
                    <option value={invoice.value}>{invoice.text}</option>
                  ))}
                </select>
                {errors.default_invoice && (
                  <p className="text-danger">
                    {errors.default_invoice.message}
                  </p>
                )}
              </div>
            </>
          )}
        </MDBCol>
        {watch("new_loc_id") === -1 && (
          <>
            <MDBCol size={6}>
              <div className="mt-3">
                <div className="tel-numbers">ZIP Code*</div>
                <MDBInput
                  {...register("zip", {
                    required: "Zip Code is required.",
                  })}
                />
                {errors.zip && (
                  <p className="text-danger">{errors.zip.message}</p>
                )}
              </div>
            </MDBCol>
          </>
        )}
      </MDBRow>
      <div style={{ display: "none" }}>
        <button
          ref={ref}
          onClick={(e) => {
            e.preventDefault();
            handleSubmit(onsubmit)();
          }}
        >
          {t("add")}
        </button>
      </div>
    </>
  );
});

export default AddBillingGroup;
